var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"funcBlock",style:({width: _vm.activeWidth})},[_c('p',{class:{tit: true, 'tit-border':!_vm.isChartShow}},[_vm._v(" "+_vm._s(_vm.tit)+" "),_vm._t("blockTit")],2),_c('div',{class:{content: true, 'border-style':_vm.showBorder, 'chart-border':!_vm.isChartShow}},[_vm._t("blockCon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }